import { lazy } from 'react'

export const TimeYouFeelHungry = lazy(() => import('./TimeYouFeelHungry'))
